import Flickity from 'flickity';

export default class GridCarousel {
  constructor(root) {
    this.root = root;
    this.bind();
  }

  bind() {
    this.flkty = new Flickity(this.root, {
      watchCSS: true,
      prevNextButtons: false,
      pageDots: true
    });
  }

  destroy() {

  }
}
